//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { ServiceConstants, TodoConstants } from "utils/constants";
import { WintSuperkollAPIModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { AxiosResponse } from "axios";
//#endregion

function useTodoGroupingHelpers() {
  const baseFilter = {
    ...ServiceConstants.DefaultFilter,
    orderByProperty: "Urgency",
    numPerPage: TodoConstants.TodosPerPage,
    orderByDescending: true,
    excludeSnoozed: true,
  };

  const todoSummary = useSelector((store: AppState) => store.todos.todoSummary);

  const getMockApiResponse = (items: WintSuperkollAPIModel.Todo[]) => {
    const response: AxiosResponse<WintUtilsWebApi.ListResponse<WintSuperkollAPIModel.Todo>> = {} as AxiosResponse<
      WintUtilsWebApi.ListResponse<WintSuperkollAPIModel.Todo>
    >;

    response.data = {
      items: items,
      totalItems: items.length,
      totalItemsWithOutFilter: items.length,
      page: 0,
      numPerPage: items.length,
    };

    return response;
  };

  return { baseFilter, todoSummary, getMockApiResponse };
}

export default useTodoGroupingHelpers;
